import React, { useState } from "react";
import { IoFastFood } from "react-icons/io5";
import { motion } from "framer-motion";
import RowContainer from "./RowContainer";
import { useSelector } from "react-redux";

const MenuContainer = () => {
  const [filter, setFilter] = useState("Thức uống");
  const products = useSelector(state => state.products);
  const statuses = useSelector(state => state.category);
  const sortedStatuses = statuses && statuses.data
    ? statuses.data.sort((a, b) => a.name.localeCompare(b.name))
    : [];
  return (
    <section className="w-full my-6" id="menu">
      <div className="w-full flex flex-col items-center justify-center">
        <p className="text-2xl font-semibold capitalize text-headingColor relative before:absolute before:rounded-lg before:content before:w-16 before:h-1 before:-bottom-2 before:left-0 before:bg-gradient-to-tr from-orange-400 to-orange-600 transition-all ease-in-out duration-100 mr-auto">
          Danh mục các món ăn
        </p>

        <div className="w-full flex items-center justify-start lg:justify-center gap-8 py-6 overflow-x-scroll scrollbar-none">
          {statuses &&
            statuses?.data?.map((category) => (
              <motion.div
                whileTap={{ scale: 0.75 }}
                key={category.id}
                className={`group ${filter === category.name ? "bg-cartNumBg" : "bg-card"
                  } w-24 min-w-[94px] h-28 cursor-pointer rounded-lg drop-shadow-xl flex flex-col gap-3 items-center justify-center hover:bg-cartNumBg `}
                onClick={() => setFilter(category.name)}
              >
                <div
                  className={`w-10 h-10 rounded-full shadow-lg ${filter === category.name
                    ? "bg-white"
                    : "bg-cartNumBg"
                    } group-hover:bg-white flex items-center justify-center`}
                >
                  <IoFastFood
                    className={`${filter === category.name
                      ? "text-textColor"
                      : "text-white"
                      } group-hover:text-textColor text-lg`}
                  />
                </div>
                <p
                  className={`text-sm ${filter === category.name
                    ? "text-white"
                    : "text-textColor"
                    } group-hover:text-white text-center`}
                >
                  {category.name}
                </p>
              </motion.div>
            ))}
        </div>

        <div className="w-full">
          <RowContainer
            flag={false}
            data={products?.filter((n) => n.product_category === filter)}
          />
        </div>
      </div>
    </section>
  );
};

export default MenuContainer;